import { render, staticRenderFns } from "./AppTable.vue?vue&type=template&id=6ace9f8f&"
import script from "./AppTable.vue?vue&type=script&lang=ts&"
export * from "./AppTable.vue?vue&type=script&lang=ts&"
import style0 from "./AppTable.vue?vue&type=style&index=0&id=6ace9f8f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports